import { PopoverContent } from "@src/controls/popoverControl";

export class ContactUs {
    isSending = ko.observable(false);
    recaptchaResponse = ko.observable('');
    sendPopover: PopoverContent;

    constructor() {
        this.sendPopover = { content: 'Please check "I\'m not a robot"', trigger: 'click', placement: 'right' };
    }

    sendEmail = () => {
        if (this.isSending()) {
            return false;
        }
        let recaptchaResponse = grecaptcha.getResponse();
        if (recaptchaResponse == "") {
            return false;
        }
        this.recaptchaResponse(recaptchaResponse);
        this.isSending(true);
        gtag('event', 'lp_contact_form');
        return true;
    }
}